import axios from "axios";
import label from "@/lang/StaticLabels.js";
import alert from "@/lang/AlertMessages.js";
import router from "@/router";
const baseUrl = "base/api/v1/";

function submitBenefitCard({ dispatch, commit }, request) {
  commit("setLoadingBtn", true, { root: true });
  return request()
    .then((res) => {
      dispatch(
        "successPOSTHandler",
        {
          server: res,
          message: res.data.message,
          redirect: false,
        },
        { root: true },
      );
    })
    .catch((error) => {
      dispatch("errorPOSTHandler", error, { root: true });
    })
    .finally(() => {
      setTimeout(() => {
        commit("setLoadingBtn", false, { root: true });
      }, 1000);
    });
}

function importBenefitCardExcel({ dispatch, commit }, url, data) {
  commit("setErrorMessage", [], { root: true });
  commit("setLoadingBtn", true, { root: true });
  return axios
    .post(baseUrl + url, data)
    .then((res) => {
      if (res.status === 202) {
        const payload = res.data && res.data.data;
        const rows = Array.isArray(payload) ? payload : payload?.data || [];
        commit(
          "setErrorMessage",
          rows.map((row) => ({
            ...row,
            error: String(row.error || "")
              .split("\n")
              .filter(Boolean)
              .join(" | "),
          })),
          { root: true },
        );
      } else {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      }
    })
    .catch((error) => {
      dispatch("errorPOSTHandler", error, { root: true });
    })
    .finally(() => {
      setTimeout(() => {
        commit("setLoadingBtn", false, { root: true });
      }, 1000);
    });
}

export default {
  // داده همه ویجت‌های داشبورد اطلاعات پایه در یک درخواست
  getDashboard({ dispatch }) {
    return axios
      .get(baseUrl + "Dashboard")
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },
  // درخت نمادهای بازار (تعریف‌شده در پارسینا ساپورت) برای پنل نرخ ارزهای داشبورد
  getMarketItemTree({ dispatch }) {
    return axios
      .get(baseUrl + "MarketItem/Tree")
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return [];
      });
  },
  // نمادهایی که کاربر جاری برای ویجت انتخاب کرده؛ اگر انتخابی نکرده باشد پیش‌فرض‌های پارسینا
  getMarketItemSelected({ dispatch }) {
    return axios
      .get(baseUrl + "MarketItem/Selected")
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },
  // همه‌ی انتخاب‌های قبلی کاربر را جایگزین می‌کند؛ لیست خالی یعنی برگشت به پیش‌فرض‌ها
  setMarketItemSelected({ dispatch }, marketItemIds) {
    return axios
      .put(baseUrl + "MarketItem/Selected", { marketItemIds })
      .then((res) => res.data || {})
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },
  // User Actions ------------------------------------------------------------------
  getUsers({ dispatch, commit }) {
    axios
      .get(baseUrl + "user")
      .then((res) => {
        commit("setUsers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getUser({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "user/" + data)
      .then((res) => {
        commit("setUser", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addUser({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "user", data)
      .then((res) => {
        commit("setUserId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addUserGroups({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "UserDataGroup", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addUserPermission({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "UserPermission", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editUser({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "user/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteUser({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "user/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  resetPassWordUser({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "User/ResetPassword/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteUserGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "UserDataGroup/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // UserBranch Actions ------------------------------------------------------------------
  getUserBranches({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "UserBranch?userId=" + data)
      .then((res) => {
        commit("setUserBranches", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addUserBranch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "UserBranch", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editUserBranch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "UserBranch/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteUserBranch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "UserBranch/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // usersGroup ------------------------------------------------------------------
  getUsersDataGroup({ dispatch, commit }) {
    axios
      .get(baseUrl + "DataGroup")
      .then((res) => {
        commit("setUsersGroup", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUserDataGroup({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "DataGroup/" + data)
      .then((res) => {
        commit("setUserGroup", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addUserDataGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "DataGroup", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editUserDataGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "DataGroup/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteUserDataGroup({ dispatch }, data) {
    axios
      .delete(baseUrl + "DataGroup/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // Roles ------------------------------------------------------------------
  getRoles({ dispatch, commit }) {
    axios
      .get(baseUrl + "role")
      .then((res) => {
        commit("setRoles", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addRole({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "role", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editRole({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "role/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteRole({ dispatch }, data) {
    axios
      .delete(baseUrl + "role/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  // Role Permission ------------------------------------------------------------------
  getRolePermission({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "RolePermission?" + data)
      .then((res) => {
        commit("setRolePermission", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUserRolePermission({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "RolePermission/" + data)
      .then((res) => {
        commit("setUserRolePermission", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addRolePermission({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "RolePermission", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Visitor Actions ------------------------------------------------------------------
  getVisitors({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "base/visitor" + data)
      .then((res) => {
        commit("setVisitors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  // Branch Actions ------------------------------------------------------------------
  getBranches({ dispatch, commit }) {
    axios
      .get(baseUrl + "Branch")
      .then((res) => {
        commit("setBranches", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBranch({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "branch/" + data)
      .then((res) => {
        commit("setBranch", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBranch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Branch", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PBASEBranchList",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBranch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "branch/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBranch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "branch/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBranchCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "Branch/MaxCode")
      .then((res) => {
        commit("setBranchCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // BranchTaxSetting Actions (تنظیمات سامانه مودیان شعبه) ---------------------------------
  // پرامیس برمی‌گردد تا فرم تنظیمات، اطلاعات را در state محلی خودش نگه دارد
  getBranchTaxSetting({ dispatch }, branchId) {
    return axios
      .get(baseUrl + "BranchTaxSetting/" + branchId)
      .then((res) => res.data.data || {})
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  // بدنه multipart/form-data است؛ اگر رکورد نباشد ساخته و اگر باشد ویرایش می‌شود
  saveBranchTaxSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post(baseUrl + "BranchTaxSetting/" + data.branchId, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // گواهی امضا مستقیم در فایلینگ ذخیره می‌شود؛ برای هر شعبه فقط یک فایل (جایگزین قبلی)
  uploadBranchTaxCertificate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    return axios
      .post("filing/api/v1/Attachment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // FiscalYear Actions ------------------------------------------------------------------
  getFiscalYears({ dispatch, commit }) {
    axios
      .get(baseUrl + "FiscalYear")
      .then((res) => {
        commit("setFiscalYears", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFiscalYear({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "FiscalYear/" + data)
      .then((res) => {
        commit("setFiscalYear", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addFiscalYear({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "FiscalYear", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PBASEFiscalYear",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editFiscalYear({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "FiscalYear/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: "PBASEFiscalYear",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteFiscalYear({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "FiscalYear/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // BranchYear Actions ------------------------------------------------------------------
  getBranchYears({ dispatch, commit }) {
    axios
      .get(baseUrl + "base/basicInformation/branchYear")
      .then((res) => {
        commit("setBranchYears", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBranchYear({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "base/basicInformation/branchYear", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBranchYear({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "base/basicInformation/branchYear/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBranchYear({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "base/basicInformation/branchYear", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  changeFiscalYear({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "admin/ChangeFiscalYear/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandlerFiscalYear",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandlerFiscalYear", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Country ------------------------------------------------------------------
  getCountries({ dispatch, commit }) {
    axios
      .get(baseUrl + "Country")
      .then((res) => {
        commit("setCountries", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCountryMaxCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "Country/MaxCode")
      .then((res) => {
        commit("setCountryMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCountry({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Country", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCountry({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "Country/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCountry({ dispatch }, data) {
    axios
      .delete(baseUrl + "Country/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // Province ------------------------------------------------------------------
  getProvinces({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "Province?" + data)
      .then((res) => {
        commit("setProvinces", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getProvinceMaxCode({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "Province/MaxCode?countryId=" + data)
      .then((res) => {
        commit("setProvinceMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addProvince({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Province", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editProvince({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "Province/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteProvince({ dispatch }, data) {
    axios
      .delete(baseUrl + "Province/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // City ------------------------------------------------------------------
  getCities({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "City?" + data)
      .then((res) => {
        commit("setCities", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCityMaxCode({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "City/MaxCode?provinceId=" + data)
      .then((res) => {
        commit("setCityMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "City", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCity({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "City/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCity({ dispatch }, data) {
    axios
      .delete(baseUrl + "city" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // Region Actions ------------------------------------------------------------------
  getRegion({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "Region?" + data)
      .then((res) => {
        commit("setRegion", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getRegionMaxCode({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "Region/MaxCode?cityId=" + data)
      .then((res) => {
        commit("setRegionMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addRegion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Region", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editRegion({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "Region/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteRegion({ dispatch }, data) {
    axios
      .delete(baseUrl + "Region/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // Person Group ------------------------------------------------------------------
  getPersonGroups({ dispatch, commit }) {
    axios
      .get(baseUrl + "PersonGroup")
      .then((res) => {
        commit("setPersonGroups", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonGroupCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "PersonGroup/MaxCode")
      .then((res) => {
        commit("setPersonGroupCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPersonGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "PersonGroup", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPersonGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "PersonGroup/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePersonGroup({ dispatch }, data) {
    axios
      .delete(baseUrl + "PersonGroup/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // Person Actions ------------------------------------------------------------------
  getPersons({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "Person?" + data)
      .then((res) => {
        commit("setPersons", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })

      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPerson({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "Person/" + data)
      .then((res) => {
        commit("setPerson", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(baseUrl + "Person/Navigation?" + data)
      .then((res) => {
        commit("setPersonNavigation", res.data.data ?? null);
      })
      .catch((error) => {
        // no record on that side of the list => null, so the form can react
        commit("setPersonNavigation", null);
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPersonBySearch({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "Person/Search" + data)
      .then((res) => {
        commit("setPersonBySearch", res.data.data ?? null);
      })
      .catch((error) => {
        // the national id matched nobody => null, so the form can react
        commit("setPersonBySearch", null);
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addPerson({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Person", data)
      .then((res) => {
        if (res.status === 200) {
          router.push({
            name: "PBASEEditPerson",
            params: { id: res.data.data },
          });
        }
        commit("setPersonId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  addPerson2({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Person", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPerson({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "Person/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  updateSignaturePerson({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "Person/UpdateSignature", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  personGroupsAssignment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "Person/PersonGroupAssignment", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePerson({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "Person?" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPersonCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "Person/MaxCode")
      .then((res) => {
        commit("setPersonCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  importExcelPerson({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Person/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: res.data.message,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Prefix Actions ------------------------------------------------------------------
  getPrefix({ dispatch, commit }) {
    axios
      .get(baseUrl + "Prefix")
      .then((res) => {
        commit("setPrefix", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPrefix({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Prefix", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPrefix({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "Prefix/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePrefix({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "Prefix/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPrefixCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "prefix/MaxCode")
      .then((res) => {
        commit("setPrefixCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  //PersonTaxFiles  Actions ------------------------------------------------------------------
  getPersonTaxFiles({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "PersonTaxDocument?" + data)
      .then((res) => {
        commit("setPersonTaxFiles", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getPersonTaxFile({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "PersonTaxDocument/" + data)
      .then((res) => {
        commit("setPersonTaxFile", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonTaxFilesCode({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "PersonTaxDocument/MaxCode?" + data)
      .then((res) => {
        commit("setPersonTaxFilesCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addPersonTaxFiles({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "PersonTaxDocument", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPersonTaxDocument({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "PersonTaxDocument/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePersonTaxDocument({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "PersonTaxDocument/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //PersonFinancialInfo  Actions ------------------------------------------------------------------
  getPersonFinancialInfo({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "PersonFinancialInfo?" + data)
      .then((res) => {
        commit("setPersonFinancialInfo", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonFinancialInfoCode({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "PersonFinancialInfo/MaxCode?" + data)
      .then((res) => {
        commit("setPersonFinancialInfoCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addPersonFinancialInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "PersonFinancialInfo", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPersonFinancialInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "PersonFinancialInfo/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePersonFinancialInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "PersonFinancialInfo/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //PersonPosition  Actions ------------------------------------------------------------------
  getPersonPosition({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "PersonPosition?" + data)
      .then((res) => {
        commit("setPersonPosition", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPersonPosition({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "PersonPosition", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPersonPosition({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "PersonPosition/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePersonPosition({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "PersonPosition/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //PersonContact  Actions ------------------------------------------------------------------
  getPersonContact({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "PersonContact?personId=" + data)
      .then((res) => {
        commit("setPersonContact", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPersonContact({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "PersonContact", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPersonContact({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "PersonContact/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePersonContact({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "PersonContact/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Sbu Actions ------------------------------------------------------------------
  getSbuTree({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "Sbu/Tree")
      .then((res) => {
        commit("setSbuTree", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getSbuList({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "Sbu")
      .then((res) => {
        commit("setSbuList", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addSbu({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "sbu", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSbu({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "sbu/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSbu({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "sbu/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // CompanyBoard Actions ------------------------------------------------------------------
  getCompanyBoard({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "companyBoard")
      .then((res) => {
        commit("setCompanyBoard", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getCompanyBoardCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "companyBoard/MaxCode")
      .then((res) => {
        commit("setCompanyBoardCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCompanyBoard({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "CompanyBoard", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCompanyBoard({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "CompanyBoard/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCompanyBoard({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "CompanyBoard/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // FloatAccountConfig Actions ------------------------------------------------------------------
  getFloatAccountConfig({ dispatch, commit }) {
    axios
      .get(baseUrl + "FloatAccountConfig")
      .then((res) => {
        commit("setFloatAccountConfig", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  editFloatAccountConfig({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "FloatAccountConfig/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // Import Excel Actions ------------------------------------------------------------------
  importExcelFloatAccount({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "FloatAccount/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: res.data.message,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // FloatAccountGroup Actions ------------------------------------------------------------------
  getFloatAccountGroup({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "FloatAccountGroup?floatAccountTypeId=" + data)
      .then((res) => {
        commit("setFloatAccountGroup", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFloatAccountGroupCodeOne({ dispatch, commit }) {
    axios
      .get(baseUrl + "FloatAccountGroup/MaxCode?floatAccountTypeId=1")
      .then((res) => {
        commit("setFloatGroupCodeOne", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountGroupCodeTwo({ dispatch, commit }) {
    axios
      .get(baseUrl + "FloatAccountGroup/MaxCode?floatAccountTypeId=2")
      .then((res) => {
        commit("setFloatGroupCodeTwo", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountGroupCodeThree({ dispatch, commit }) {
    axios
      .get(baseUrl + "FloatAccountGroup/MaxCode?floatAccountTypeId=3")
      .then((res) => {
        commit("setFloatGroupCodeThree", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountGroupCodeFour({ dispatch, commit }) {
    axios
      .get(baseUrl + "FloatAccountGroup/MaxCode?floatAccountTypeId=4")
      .then((res) => {
        commit("setFloatGroupCodeFour", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountGroupCodeFive({ dispatch, commit }) {
    axios
      .get(baseUrl + "FloatAccountGroup/MaxCode?floatAccountTypeId=5")
      .then((res) => {
        commit("setFloatGroupCodeFive", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addFloatAccountGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "FloatAccountGroup", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editFloatAccountGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "FloatAccountGroup/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteFloatAccountGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "FloatAccountGroup/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // FloatAccount Actions ------------------------------------------------------------------
  getFloatAccountOne({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "FloatAccount?" + data)
      .then((res) => {
        commit("setFloatAccountOne", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountTwo({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "FloatAccount?" + data)
      .then((res) => {
        commit("setFloatAccountTwo", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFloatAccountThree({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "FloatAccount?" + data)
      .then((res) => {
        commit("setFloatAccountThree", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFloatAccountFour({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "FloatAccount?" + data)
      .then((res) => {
        commit("setFloatAccountFour", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFloatAccountFive({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "FloatAccount?" + data)
      .then((res) => {
        commit("setFloatAccountFive", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getFloatAccountCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "FloatAccount/MaxCode?floatAccountTypeId=1")
      .then((res) => {
        commit("setFloatAccountCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountCodeTwo({ dispatch, commit }) {
    axios
      .get(baseUrl + "FloatAccount/MaxCode?floatAccountTypeId=2")
      .then((res) => {
        commit("setFloatAccountCodeTwo", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountCodeThree({ dispatch, commit }) {
    axios
      .get(baseUrl + "FloatAccount/MaxCode?floatAccountTypeId=3")
      .then((res) => {
        commit("setFloatAccountCodeThree", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountCodeFour({ dispatch, commit }) {
    axios
      .get(baseUrl + "FloatAccount/MaxCode?floatAccountTypeId=4")
      .then((res) => {
        commit("setFloatAccountCodeFour", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFloatAccountCodeFive({ dispatch, commit }) {
    axios
      .get(baseUrl + "FloatAccount/MaxCode?floatAccountTypeId=5")
      .then((res) => {
        commit("setFloatAccountCodeFive", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addFloatAccount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "FloatAccount", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editFloatAccount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "FloatAccount/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteFloatAccount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "FloatAccount/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // UserLimit Actions ------------------------------------------------------------------
  getUserLimitPersons({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "UserLimit/GetPersons?userId=" + data)
      .then((res) => {
        commit("setUserLimitPersons", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  deleteUserLimitPersons({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "UserLimit/DeletePersons", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getuserLimitFloatAccountsOne({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        baseUrl +
          "UserLimit/GetFloatAccounts?floatAccountTypeId=1&userId=" +
          data,
      )
      .then((res) => {
        commit("setUserLimitFloatAccountsOne", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getuserLimitFloatAccountsTwo({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        baseUrl +
          "UserLimit/GetFloatAccounts?floatAccountTypeId=2&userId=" +
          data,
      )
      .then((res) => {
        commit("setUserLimitFloatAccountsTwo", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getuserLimitFloatAccountsThree({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        baseUrl +
          "UserLimit/GetFloatAccounts?floatAccountTypeId=3&userId=" +
          data,
      )
      .then((res) => {
        commit("setUserLimitFloatAccountsThree", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getuserLimitFloatAccountsFour({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        baseUrl +
          "UserLimit/GetFloatAccounts?floatAccountTypeId=4&userId=" +
          data,
      )
      .then((res) => {
        commit("setUserLimitFloatAccountsFour", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getuserLimitFloatAccountsFive({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(
        baseUrl +
          "UserLimit/GetFloatAccounts?floatAccountTypeId=5&userId=" +
          data,
      )
      .then((res) => {
        commit("setUserLimitFloatAccountsFive", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  deleteFloatAccounts({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "UserLimit/DeleteFloatAccounts", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // UserLimit Actions ------------------------------------------------------------------
  ChangeUserLimitPersons({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "UserLimit/Persons", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  ChangeUserLimitFloatAccounts({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "UserLimit/FloatAccounts", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // Position Information Actions ------------------------------------------------------------------
  getPositionInfo({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "PositionInfo")
      .then((res) => {
        commit("setPositionInfo", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPositionCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "PositionInfo/MaxCode")
      .then((res) => {
        commit("setPositionCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addPositionInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "PositionInfo", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPositionInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "PositionInfo/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePositionInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "PositionInfo/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  importExcelPositionInfo({ dispatch, commit }, data) {
    commit("setErrorMessage", [], { root: true });
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "PositionInfo/ImportAsExcel", data)
      .then((res) => {
        if (res.status === 202) {
          commit("setErrorMessage", res.data.data.data, { root: true });
        } else {
          dispatch(
            "successPOSTHandler",
            {
              server: res,
              message: res.data.message,
              redirect: false,
            },
            { root: true },
          );
          commit("setModalVisibility", false, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //CartableConfirmPriority Actions ------------------------------------------------------------------
  getCartableConfirmPriority({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "CartableConfirmPriority?" + data)
      .then((res) => {
        commit("setCartableConfirmPriority", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addCartableConfirmPriority({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "CartableConfirmPriority", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCartableConfirmPriority({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "CartableConfirmPriority/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCartableConfirmPriority({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "CartableConfirmPriority/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //SignatureDetail Actions ------------------------------------------------------------------
  getSignatureDetail({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "SignatureDetail?" + data)
      .then((res) => {
        commit("setSignatureDetail", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addSignatureDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "SignatureDetail", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSignatureDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "SignatureDetail/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSignatureDetail({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "SignatureDetail?ids=" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //AddImage Company Actions ------------------------------------------------------------------
  addCompanyImage({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Branch/AddImage", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCompanyImage({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "Branch/DeleteImage", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPersonByMobile({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "Branch/GetPerson?mobile=" + data)
      .then((res) => {
        commit("setPersonByMobile", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  addCompanyContact({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Branch/AddContact", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCompanyContact({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "Branch/DeleteContact", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //CurrencyType Actions ------------------------------------------------------------------
  getCurrencyTypes({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "CurrencyType")
      .then((res) => {
        commit("setCurrencyTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addCurrencyType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "CurrencyType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCurrencyType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "CurrencyType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  changeDefaultCurrencyType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "CurrencyType/change", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCurrencyType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "CurrencyType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getCurrencyTypeCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "CurrencyType/MaxCode")
      .then((res) => {
        commit("setCurrencyTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  //CurrencyRate Actions ------------------------------------------------------------------
  getCurrencyRates({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "CurrencyRate")
      .then((res) => {
        commit("setCurrencyRates", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addCurrencyRate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "CurrencyRate", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCurrencyRate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "CurrencyRate/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCurrencyRate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "CurrencyRate", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // TransactionInfo Actions ------------------------------------------------------------------
  getTransactionInfo({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "TransactionInfo?" + data)
      .then((res) => {
        commit("setTransactionInfo", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  editTransactionInfo({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "TransactionInfo", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // VehicleTypes Actions ------------------------------------------------------------------
  getVehicleType({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "VehicleType")
      .then((res) => {
        commit("setVehicleType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addVehicleType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "VehicleType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editVehicleType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "VehicleType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteVehicleType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "VehicleType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //Suppliers Actions ------------------------------------------------------------------
  getSuppliers({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "Supplier")
      .then((res) => {
        commit("setSuppliers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSupplier({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "supplier/" + data)
      .then((res) => {
        commit("setSupplier", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSupplierByPerson({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(baseUrl + "Supplier/GetPerson?personId=" + data)
      .then((res) => {
        commit("setSupplierByPerson", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addSupplier({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Supplier", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSupplier({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "Supplier/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSupplier({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "Supplier", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //Buyers Actions ------------------------------------------------------------------
  getBuyers({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "Buyer")
      .then((res) => {
        commit("setBuyers", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBuyer({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "Buyer/" + data)
      .then((res) => {
        commit("setBuyer", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBuyerByPerson({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(baseUrl + "Buyer/GetPerson?personId=" + data)
      .then((res) => {
        commit("setBuyerByPerson", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addBuyer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Buyer", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBuyer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "Buyer/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBuyer({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "Buyer", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  //SmsSetting Actions ------------------------------------------------------------------
  getSmsSetting({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get("Notify/api/v1/basic/SmsSetting")
      .then((res) => {
        commit("setSmsSetting", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addSmsSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Notify/api/v1/basic/SmsSetting", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSmsSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("Notify/api/v1/basic/SmsSetting/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSmsSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete("Notify/api/v1/basic/SmsSetting", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Setting Actions ------------------------------------------------------------------
  getSettings({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "Setting")
      .then((res) => {
        commit("setSettings", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  editSetting({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "Setting/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  //Contractors Actions ------------------------------------------------------------------
  getContractors({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "Contractor")
      .then((res) => {
        commit("setContractors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getContractor({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "Contractor/" + data)
      .then((res) => {
        commit("setContractors", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addContractor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Contractor", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editContractor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "Contractor/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteContractor({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "Contractor", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Branches And Offices --------------------------------------
  getBranchesAndOffices({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "PersonAddress?" + data)
      .then((res) => {
        commit("setBranchesAndOffices", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBranchesAndOfficesById({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "PersonAddress/" + data)
      .then((res) => {
        commit("setBranchesAndOfficesById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBranchesAndOffices({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "PersonAddress", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBranchesAndOffices({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "PersonAddress/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBranchesAndOffices({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "PersonAddress", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBranchesAndOfficesCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "PersonAddress/MaxCode")
      .then((res) => {
        commit("setBranchesAndOfficesCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // saleAddMinus ------------------------------------------------------
  getSaleAddminus({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "SaleAddMinus")
      .then((res) => {
        commit("setSaleAddMinus", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getSaleAddMinusById({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "SaleAddMinus/getBy" + data)
      .then((res) => {
        commit("setSaleAddMinusById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addSaleAddMinus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "SaleAddMinus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteSaleAddMinus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "SaleAddMinus", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editSaleAddMinus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "SaleAddMinus/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSaleAddMinusMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(baseUrl + "SaleAddMinus/MaxCode")
      .then((res) => {
        commit("setSaleAddMinusMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSaleAddMinusNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(baseUrl + "SaleAddMinus/Navigation?" + data)
      .then((res) => {
        commit("setSaleAddMinusById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getSaleAddMinusPriority({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(baseUrl + "SaleAddMinus/MaxPriority")
      .then((res) => {
        commit("setSaleAddMinusPriority", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // BuyAddMinus ------------------------------------------------------
  getBuyAddMinuses({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "BuyAddMinus")
      .then((res) => {
        commit("setBuyAddMinuses", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBuyAddMinus({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "BuyAddMinus/" + data)
      .then((res) => {
        commit("setBuyAddMinus", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBuyAddMinusSearch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(baseUrl + "BuyAddMinus/Get/" + data)
      .then((res) => {
        commit("setBuyAddMinusSearch", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addBuyAddMinus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "BuyAddMinus", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBuyAddMinus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "BuyAddMinus/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBuyAddMinus({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "BuyAddMinus", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBuyAddMinusCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(baseUrl + "BuyAddMinus/MaxCode")
      .then((res) => {
        commit("setBuyAddMinusCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBuyAddMinusPriority({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(baseUrl + "BuyAddMinus/MaxPriority")
      .then((res) => {
        commit("setBuyAddMinusPriority", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getBuyAddMinusNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(baseUrl + "BuyAddMinus/Navigation?" + data)
      .then((res) => {
        commit("setBuyAddMinusNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // Banks Actions ------------------------------------------------------------------
  getBanks({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "Bank")
      .then((res) => {
        commit("setBanks", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBankCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "Bank/MaxCode")
      .then((res) => {
        commit("setBankMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addBank({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Bank", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addBank2({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Bank", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBank({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "Bank/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBank({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "Bank", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // BankBranch Actions ------------------------------------------------------------------
  getBankBranches({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "BankBranch?" + data)
      .then((res) => {
        commit("setBankBranches", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getBankBranchCode({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "BankBranch/MaxCode?id=" + data)
      .then((res) => {
        commit("setBankBranchMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addBankBranch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "BankBranch", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  addBankBranch2({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "BankBranch", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler2",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler2", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editBankBranch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "BankBranch/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteBankBranch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "BankBranch", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // DocumentTypes Actions ------------------------------------------------------------------
  getDocumentTypes({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "DocumentType")
      .then((res) => {
        commit("setDocumentTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getDocumentTypesById({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "DocumentType/GetById?" + data)
      .then((res) => {
        commit("setDocumentTypesById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addDocumentType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "DocumentType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDocumentType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "DocumentType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editDocumentType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "DocumentType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getDocumentTypesMaxCode({ dispatch, commit }) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(baseUrl + "DocumentType/GetMaxCode")
      .then((res) => {
        commit("setDocumentTypesMaxCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  copyReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "Report/Copy", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "Report/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteReport({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "Report", { data: [].concat(data) })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Company Actions ------------------------------------------------------------------
  getCompanies({ dispatch, commit }) {
    axios
      .get(baseUrl + "parsina/Company")
      .then((res) => {
        commit("setCompanies", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCompany({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "parsina/Company/" + data)
      .then((res) => {
        commit("setCompany", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCompany({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "parsina/Company", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCompany({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "parsina/Company/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCompany({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "parsina/Company/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Insurance Type actions --------------------------------
  getInsuranceType({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "admin/InsuranceType")
      .then((res) => {
        commit("setInsuranceType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getInsuranceTypeById({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "admin/InsuranceType/" + data)
      .then((res) => {
        commit("setInsuranceTypeById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getInsuranceTypeCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "admin/InsuranceType/MaxCode")
      .then((res) => {
        commit("setInsuranceTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addInsuranceType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "admin/InsuranceType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editInsuranceType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "admin/InsuranceType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteInsuranceType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "admin/InsuranceType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Employment Type actions --------------------------------
  getEmploymentType({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "admin/EmploymentType")
      .then((res) => {
        commit("setEmploymentType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getEmploymentTypeById({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "admin/EmploymentType/" + data)
      .then((res) => {
        commit("setEmploymentTypeById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getEmploymentTypeCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "admin/EmploymentType/MaxCode")
      .then((res) => {
        commit("setEmploymentTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addEmploymentType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "admin/EmploymentType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editEmploymentType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "admin/EmploymentType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteEmploymentType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "admin/EmploymentType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Study Field Type actions --------------------------------
  getStudyFieldType({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "admin/StudyFieldType")
      .then((res) => {
        commit("setStudyFieldType", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getStudyFieldTypeById({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "admin/StudyFieldType/" + data)
      .then((res) => {
        commit("setStudyFieldTypeById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getStudyFieldTypeCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "admin/StudyFieldType/MaxCode")
      .then((res) => {
        commit("setStudyFieldTypeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addStudyFieldType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "admin/StudyFieldType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editStudyFieldType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "admin/StudyFieldType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteStudyFieldType({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "admin/StudyFieldType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Degree actions --------------------------------
  getDegree({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "admin/DegreeType")
      .then((res) => {
        commit("setDegree", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getDegreeById({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "admin/DegreeType/" + data)
      .then((res) => {
        commit("setDegreeById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDegreeCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "admin/DegreeType/MaxCode")
      .then((res) => {
        commit("setDegreeCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addDegree({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "admin/DegreeType", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editDegree({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "admin/DegreeType/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDegree({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "admin/DegreeType", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Department actions --------------------------------
  getDepartments({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "admin/Department")
      .then((res) => {
        commit("setDepartments", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getDepartmentById({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "admin/Department/" + data)
      .then((res) => {
        commit("setDepartmentById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getDepartmentCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "admin/Department/MaxCode")
      .then((res) => {
        commit("setDepartmentCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addDepartment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "admin/Department", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editDepartment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "admin/Department/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteDepartment({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "admin/Department", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // Personnel actions -----------------------------------------------------
  getPersonnels({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "admin/Personnel")
      .then((res) => {
        commit("setPersonnels", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPersonnelById({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "admin/Personnel/" + data)
      .then((res) => {
        commit("setPersonnelById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonnelBySearch({ dispatch, commit }, data) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "admin/Personnel/Search" + data)
      .then((res) => {
        commit("setPersonnelBySearch", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addPersonnel({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "admin/Personnel", data)
      .then((res) => {
        commit("setPersonnelId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPersonnel({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "admin/Personnel/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editPersonnelGroup({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "admin/Personnel/UpdateGroup", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deletePersonnel({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "admin/Personnel", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPersonnelCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "admin/Personnel/MaxCode")
      .then((res) => {
        commit("setPersonnelCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPersonnelNavigation({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get(baseUrl + "admin/Personnel/Navigation?" + data)
      .then((res) => {
        commit("setPersonnelNavigation", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // ServiceCenter actions -----------------------------------------------------
  getServiceCenters({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "ServiceCenter")
      .then((res) => {
        commit("setServiceCenters", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },
  getServiceCenterById({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "ServiceCenter/" + data)
      .then((res) => {
        commit("setServiceCenterById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  addServiceCenter({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "ServiceCenter", data)
      .then((res) => {
        commit("setServiceCenterId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editServiceCenter({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "ServiceCenter/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteServiceCenter({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "ServiceCenter", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getServiceCenterCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "ServiceCenter/MaxCode")
      .then((res) => {
        commit("setServiceCenterCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // UnitCount actions -----------------------------------------------------
  getUnitCount({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "UnitCount")
      .then((res) => {
        commit("setUnitCount", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  addUnitCount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "UnitCount", data)
      .then((res) => {
        commit("setUnitCountId", res.data.data);
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  editUnitCount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "UnitCount/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  deleteUnitCount({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "UnitCount", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  getUnitCountCode({ dispatch, commit }) {
    axios
      .get(baseUrl + "UnitCount/GetMaxCode")
      .then((res) => {
        commit("setUnitCountCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  // VoucherTemplate Actions ------------------------------------------------------------------
  getVoucherTemplate({ dispatch, commit }, data) {
    axios
      .get(baseUrl + "VoucherTemplate?" + data)
      .then((res) => {
        commit("setVoucherTemplate", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addVoucherTemplate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "VoucherTemplate", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editVoucherTemplate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "VoucherTemplate/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  reorderVoucherTemplate({ dispatch, commit }, data) {
    return Promise.all(
      data.map((item) =>
        axios.put(baseUrl + "VoucherTemplate/" + item.id, item.value),
      ),
    )
      .then((responses) => {
        const failed = responses.find((res) => res.status !== 200);
        if (failed) {
          if (failed.data && failed.data.message) {
            commit("setError", failed.data.message, { root: true });
          }
        } else {
          const last = responses[responses.length - 1];
          commit("setSuccess", last.data.message, { root: true });
        }
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteVoucherTemplate({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "VoucherTemplate", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // PosTerminal Actions - دستگاه‌های پوز ---------------------------------------
  // data: رشتهٔ کوئری فیلترها (isActive)
  getPosTerminals({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "PosTerminal" + (data ? "?" + data : ""))
      .then((res) => {
        commit("setPosTerminals", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getPosTerminalById({ dispatch }, id) {
    return axios
      .get(baseUrl + "PosTerminal/" + id)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  getPosTerminalMaxCode({ dispatch }) {
    return axios
      .get(baseUrl + "PosTerminal/MaxCode")
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
        return null;
      });
  },

  addPosTerminal({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(baseUrl + "PosTerminal", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // data: { id, value }
  editPosTerminal({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put(baseUrl + "PosTerminal/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // data: آرایه شناسه‌ها
  deletePosTerminal({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .delete(baseUrl + "PosTerminal", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getPosTerminalTypes({ dispatch, commit }) {
    axios
      .get(baseUrl + "DropDown/PosTerminalTypes")
      .then((res) => {
        commit("setPosTerminalTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getConnectionTypes({ dispatch, commit }) {
    axios
      .get(baseUrl + "DropDown/ConnectionTypes")
      .then((res) => {
        commit("setConnectionTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // BenefitCard Actions - بن کارت -----------------------------------------------
  // data: رشتهٔ کوئری فیلترها (isActive, isBlock, cardTypeId, ownerPersonClubId)
  getBenefitCards({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "BenefitCard" + (data ? "?" + data : ""))
      .then((res) => {
        commit("setBenefitCards", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBenefitCardById({ dispatch }, id) {
    return axios
      .get(baseUrl + "BenefitCard/" + id)
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return null;
      });
  },

  getBenefitCardMaxCode({ dispatch }) {
    return axios
      .get(baseUrl + "BenefitCard/MaxCode")
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
        return null;
      });
  },

  addBenefitCard(context, data) {
    return submitBenefitCard(context, () =>
      axios.post(baseUrl + "BenefitCard", data),
    );
  },

  // data: { id, value }
  editBenefitCard(context, data) {
    return submitBenefitCard(context, () =>
      axios.put(baseUrl + "BenefitCard/" + data.id, data.value),
    );
  },

  // data: آرایه شناسه‌ها
  deleteBenefitCard(context, data) {
    return submitBenefitCard(context, () =>
      axios.delete(baseUrl + "BenefitCard", { data }),
    );
  },

  // data: { ids, isActive?, isBlock? } — فیلدی که نیاید تغییر نمی‌کند
  changeStatusBenefitCard(context, data) {
    return submitBenefitCard(context, () =>
      axios.put(baseUrl + "BenefitCard/ChangeStatus", data),
    );
  },

  // data: { ids, expireDate }
  extendExpireDateBenefitCard(context, data) {
    return submitBenefitCard(context, () =>
      axios.put(baseUrl + "BenefitCard/ExtendExpireDate", data),
    );
  },

  // data: { id, value: { cardNumber, cardUId } }
  changeCardNumberBenefitCard(context, data) {
    return submitBenefitCard(context, () =>
      axios.put(
        baseUrl + "BenefitCard/" + data.id + "/ChangeCardNumber",
        data.value,
      ),
    );
  },

  // data: { ids, isPinRequired, password }
  changePasswordBenefitCard(context, data) {
    return submitBenefitCard(context, () =>
      axios.put(baseUrl + "BenefitCard/ChangePassword", data),
    );
  },

  // data: { ids, ownerPersonClubId }
  assignOwnerBenefitCard(context, data) {
    return submitBenefitCard(context, () =>
      axios.put(baseUrl + "BenefitCard/AssignOwner", data),
    );
  },

  getBenefitCardTypes({ dispatch, commit }) {
    axios
      .get(baseUrl + "DropDown/BenefitCardTypes")
      .then((res) => {
        commit("setBenefitCardTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // formData: file, sheetName, updateIfExist
  importExcelBenefitCard(context, data) {
    return importBenefitCardExcel(context, "BenefitCard/ImportAsExcel", data);
  },

  // formData: file, sheetName
  importExcelOwnerBenefitCard(context, data) {
    return importBenefitCardExcel(
      context,
      "BenefitCard/ImportOwnerAsExcel",
      data,
    );
  },

  // formData: file, sheetName, date
  importExcelChargeBenefitCard(context, data) {
    return importBenefitCardExcel(
      context,
      "BenefitCardTransaction/ImportChargeAsExcel",
      data,
    );
  },

  // BenefitCardTransaction Actions - گردش بن کارت -------------------------------
  // data: رشتهٔ کوئری فیلترها (cardId, fromDate, toDate, transactionTypeId)
  getBenefitCardTransactions({ dispatch, commit }, data = "") {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get(baseUrl + "BenefitCardTransaction" + (data ? "?" + data : ""))
      .then((res) => {
        commit("setBenefitCardTransactions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  getBenefitCardTransactionTypes({ dispatch, commit }) {
    axios
      .get(baseUrl + "DropDown/BenefitCardTransactionTypes")
      .then((res) => {
        commit("setBenefitCardTransactionTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // کارت پیدا نشود: پاسخ 200 با data = null
  getBenefitCardByCardNumber({ dispatch }, cardNumber) {
    return axios
      .get(
        baseUrl +
          "BenefitCardTransaction/ByCardNumber?cardNumber=" +
          encodeURIComponent(cardNumber),
      )
      .then((res) => res.data.data)
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return null;
      });
  },

  // data: { ids, amount, date, description, personId, floatAccountId1..5, floatAccountText }
  chargeBenefitCard(context, data) {
    return submitBenefitCard(context, () =>
      axios.post(baseUrl + "BenefitCardTransaction/Charge", data),
    );
  },

  // data: { fromCardNumber, toCardNumber, amount, date, description }
  transferBenefitCard(context, data) {
    return submitBenefitCard(context, () =>
      axios.post(baseUrl + "BenefitCardTransaction/Transfer", data),
    );
  },
};
